<template>
  <div class="mobile-charts">
    <header class="title">
      <img class="logo" :src="img" alt="" />
      酒加数据分析
    </header>
    <div class="input-wrapper hd">
      <div class="input-box">
        <span class="name">交易商家平台：</span>
        <div class="input">
          <el-select
            :disabled="$store.state.entryType === 'seller'"
            v-model="condition.merchantId"
            placeholder="请选择"
            clearable
          >
            <el-option
              :label="item.label"
              :value="item.value"
              :key="item.value"
              v-for="item in filterDownData('merchantList')"
            />
          </el-select>
        </div>
      </div>
      <div class="input-box">
        <span class="name">归属小程序：</span>
        <div class="input">
          <el-select
            v-model="condition.appletsId"
            placeholder="请选择"
            clearable
          >
            <el-option
              :label="item.label"
              :value="item.value"
              :key="item.value"
              v-for="item in filterApplet"
            />
          </el-select>
        </div>
      </div>
      <div class="input-box">
        <span class="name">筛选日期：</span>
        <div class="input">
          <el-select v-model="condition.date" placeholder="筛选日期" clearable>
            <el-option label="当天" value="1" />
            <el-option label="7天" value="2" />
            <el-option label="30天" value="3" />
            <el-option label="半年" value="4" />
            <el-option label="1年" value="5" />
          </el-select>
        </div>
      </div>
      <el-button
        size="60"
        round
        class="iconfont icon-sousuo"
        @click="searchData"
      />
    </div>

    <div class="box">
      <div class="chart">
        <div class="winner-flex">
          <h3 class="chart-title">销售数据统计表</h3>
        </div>

        <Histogram
          v-bind="$attrs"
          :histogramData="salesData"
          :histogramSettings="chartHisSetting"
          :dataZoom="dataZoom"
          :dataEmpty="salesData.rows && salesData.rows.length === 0"
          :legendVisible="true"
        />
      </div>

      <div class="chart">
        <div class="winner-flex">
          <h3 class="chart-title">实时订单交易表</h3>
        </div>
        <el-table
          v-load="{ el: '.el-table__body-wrapper', func: loadMore }"
          ref="table"
          :data="tableData"
          :height="250"
        >
          <el-table-column
            label="交易时间"
            prop="payment_time"
            align="center"
          />
          <el-table-column label="账号" prop="member_name" align="center" />
          <el-table-column
            label="订单金额"
            prop="order_amount"
            align="center"
          />
          <el-table-column label="订单类型" align="center">
            <template slot-scope="scope">
              {{ scope.row.order_type | formatGoodsType }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="chart">
        <div class="winner-flex">
          <h3 class="chart-title">TOP10 销售商家</h3>
        </div>
        <Pie
          v-bind="$attrs"
          :chartPieSettings="chartPieSettings"
          :chartOptions="chartPieOptions"
          :chartPieData="chartPieData"
          :legendVisible="true"
          :loading="$attrs.loading"
          height="400px"
          :dataEmpty="chartPieData.rows && chartPieData.rows.length === 0"
        />
      </div>

      <div class="chart">
        <div class="winner-flex">
          <h3 class="chart-title">TOP6 酒品类目排名</h3>
        </div>
        <Ring
          v-bind="$attrs"
          :chartRingData="chartRingData"
          :chartOptions="chartRingOptions"
          :chartRingSettings="chartRingSettings"
          :legendVisible="true"
          :loading="$attrs.loading"
          :dataEmpty="chartRingData.rows && chartRingData.rows.length === 0"
        />
      </div>

      <div class="chart">
        <div class="winner-flex">
          <h3 class="chart-title">TOP10 酒品销售数量</h3>
        </div>
        <Bar
          v-bind="$attrs"
          :chartBarSettings="chartBarSettings"
          :chartOptions="chartBarOptions"
          :chartBarData="chartBarData"
          :legendVisible="true"
          :loading="$attrs.loading"
          :dataEmpty="chartBarData.rows && chartBarData.rows.length === 0"
        />
      </div>

      <div class="chart">
        <div class="winner-flex">
          <h3 class="chart-title">会员比例</h3>
        </div>
        <Pie
          v-bind="$attrs"
          :chartPieSettings="chartVipSettings"
          :chartPieData="chartVipData"
          :legendVisible="true"
          :loading="$attrs.loading"
          :dataEmpty="chartVipData.rows && chartVipData.rows.length === 0"
        />
      </div>
    </div>
  </div>
</template>
<script>
import img from '@/assets/img/winner_logo.png'
import filterDownData from 'mixins/filterDownData'
import Ring from 'components/Chart/Ring'
import chartLine from 'components/Chart/Line/'
import Histogram from 'components/Chart/histogram'
import Pie from 'components/Chart/Pie/'
import Bar from 'components/Chart/Bar/'
import utils from '@/common/js/utils'

const _debounce = utils._debounce

export default {
  name: 'mobileCharts',
  mixins: [filterDownData],
  components: {
    Ring,
    Histogram,
    chartLine,
    Pie,
    Bar
  },
  computed: {
    filterApplet() {
      const applets = this.filterDownData('appletsList').filter(v => {
        return v.merchantId === this.condition.merchantId
      })
      this.condition.appletsId = ''
      return applets
    }
  },
  data() {
    // legendName: {
    //   '访问用户': '访问用户 total: 10000'
    // }
    this.chartHisSetting = {
      labelMap: {
        date_time: '时间',
        cross_avg_amount: '跨境',
        duty_avg_amount: '完税',
        wine_avg_amount: '期酒'
      }
    }
    this.chartLineSettings = {}
    this.chartLineOptions = {
      // tooltip: {
      //   formatter(params) {
      //     let str = ''
      //     console.log(  params)
      //     params.forEach(v => {
      //       str += `${v.marker} ${v.seriesName}: ${v.value[1]}<br>`
      //     })
      //     return str
      //   }
      // }
    }
    this.chartPieSettings = {
      roseType: 'radius',
      labelMap: {
        order_number: '销售总订单数',
        app_name: '销售平台商家'
      }
    }
    this.chartPieOptions = {
      dimension: 'order_number',
      legend: {
        bottom: '-20px'
      }
    }

    this.chartRingSettings = {
      labelMap: {
        class_name: '类目',
        goods_quantity: '数量'
      }
    }
    this.chartRingOptions = {
      legend: {
        bottom: '-20px'
      }
    }
    this.chartBarOptions = {
      yAxis: {
        axisLabel: {
          show: false,
          formatter: function(value, index) {
            return value
              .split(' ')
              .slice(-1)[0]
              .slice(0, 1)
          }
        }
      }
    }
    this.chartBarSettings = {
      metrics: ['sales_number'],
      dataOrder: {
        label: 'sales_number',
        order: 'desc'
      },
      labelMap: {
        goods_name: '酒品名',
        sales_number: '销售数量'
      }
    }
    this.chartVipSettings = {
      labelMap: {
        member_gender: '性别',
        member_number: '人数'
      },
      level: [['男', '女'], ['保密']]
    }
    this.dataZoom = [
      {
        type: 'slider',
        start: 0,
        end: 100
      }
    ]
    return {
      condition: {
        merchantId: '',
        appletsId: '',
        date: '1'
      },
      img: img,
      tableData: [],
      salesData: {
        columns: [
          'date_time',
          'cross_avg_amount',
          'duty_avg_amount',
          'wine_avg_amount'
        ],
        rows: []
      },
      chartPieData: {
        columns: ['app_name', 'order_number'],
        rows: []
      },
      chartRingData: {
        columns: ['class_name', 'goods_quantity'],
        rows: []
      },
      chartBarData: {
        columns: ['goods_name', 'sales_number'],
        rows: []
      },
      chartVipData: {
        columns: ['member_gender', 'member_number'],
        rows: []
      }
    }
  },

  created() {
    if (this.$store.state.entryType === 'seller') {
      this.condition.merchantId = this.$store.state.merchantId
      this.condition.appletsId =
        this.filterApplet.length > 0 ? this.filterApplet[0].value : ''
      this.searchData()
    }
  },

  methods: {
    /**
     * 筛选数据
     */
    searchData() {
      const { merchantId, appletsId, date } = this.condition
      const data = {
        merchant_id: merchantId,
        applet_id: appletsId,
        selected_date: date
      }
      this.api.getMobileCharts(data).then(res => {
        this.allTableData = res.member_order_data
        this.slice = 0
        this.tableData = this.allTableData.slice(0, 50)
        this.salesData.rows = res.order_data
        this.chartPieData.rows = res.applet_order_data
        this.chartRingData.rows = res.class_data
        this.chartBarData.rows = res.goods_list
        this.chartVipData.rows = res.gender_list
      })
    },
    /**
     * 表格加载更多
     */
    loadMore: _debounce(function() {
      this.slice += 50
      this.tableData = [
        ...this.tableData,
        ...this.allTableData.slice(this.slice, this.slice + 50)
      ]
    }, 100)
  }
}
</script>
<style lang="scss">
.mobile-charts {
  padding: 0.6rem;

  .title {
    font-size: 16px;
    font-weight: bold;
  }

  .winner-flex {
    justify-content: space-between;
    margin-bottom: 1.3rem;
  }

  .logo {
    width: 1.8rem;
    height: 1.8rem;
  }

  .input-wrapper {
    margin-top: 1.3rem;
    padding: 1.3rem;

    .name {
      margin-bottom: 0.6rem;
    }

    .input-box {
      margin-right: 0;
      width: 100%;
    }

    .input {
      width: 100%;
    }
  }

  .chart {
    margin-bottom: 1.3rem;
  }
}
</style>
